<template>
  <div>
    <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">

        <div style="margin-top: 20px; width: 50%;">
            <span type="label">First Name</span>
            <br>
            <el-input 
                @focus="$event.target.select()"
                size="small"
                v-model="$store.state.master.props.first_name"
                :style="'width: 95%; '">
            </el-input>
        </div>
        <div style="margin-top: 20px; width: 50%;">
            <span type="label">Last Name</span>
            <br>
            <el-input 
                @focus="$event.target.select()"
                size="small"
                v-model="$store.state.master.props.last_name"
                :style="'width: 100%; '">
            </el-input>
        </div>
    </div>
    
    <div style="margin-top: 10px; width: 100%;">
        <span type="label">Brand Name</span>
        <br>
        <el-input 
            @focus="$event.target.select()"
            size="small"
            v-model="$store.state.master.props.brand_name"
            :style="'width: 100%; '">
        </el-input>
    </div>

    <div style="margin-top: 10px; width: 100%;">
        <span type="label">Email Address</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            v-model="$store.state.master.props.email_address"
            :style="'width: 100%; '">
        </el-input>
    </div>
    <div style="margin-top: 10px; width: 100%;">
        <span type="label">Mobile Number</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            type="number"
            v-model.trim="$store.state.master.props.mobile_number"
            :style="'width: 100%; '"
            class="input-with-select">
            <el-select 
                default-first-option
                v-model="$store.state.master.props.mobile_number_calling_code"
                filterable 
                slot="prepend" 
                placeholder="Code"
                style="width: 100px;"
                >
            <el-option
                v-for="(data, index) in $store.getters.getCountryList"
                :key="index"
                :label="'+'+data.calling_code+' '+data.country_name"
                :value="'+'+data.calling_code+' '+data.country_name">
                <span style="float: left" v-html="'+'+data.calling_code"></span>
                <span style="float: right;">{{ data.country_icon+' '+data.country_name }}</span>
            </el-option>
        </el-select>
        </el-input>
    </div>
    
    <div style="margin-top: 30px; width: 100%; text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <span>
            Your contact information will only be used to schedule a demo and tech support responses in future.<br>We will not make any cold calls or sales calls.
        </span>
        <span style="margin-top: 10px;">
            For more information please visit our <router-link to="privacy-policy" style="color: black;">Privacy Policy</router-link>.
        </span>
        <span style="margin-top: 10px;">
            By clicking the <b>Submit</b> button, you agree to our <router-link to="terms-and-conditions" style="color: black;">Terms and Conditions</router-link>.
        </span>
    </div>
    <div v-if="getWarning" style="margin-top: 20px; width: 100%; color: red; text-align: center;">
        <span v-html="getWarningMessage">
            
        </span>
    </div>
    <div style="margin-top: 20px; width: 100%; display: flex; flex-direction: row; justify-content: center; align-items: center; text-align: center;">
        <VueRecaptcha 
            @verify="approve_submission=true" 
            @fail="approve_submission=false" 
            @error="approve_submission=false" 
            @expire="approve_submission=false" 
            sitekey="6LdbL1ooAAAAACx0XEiyJtqYVKbWogrmjgJXwiJ8"></VueRecaptcha>
    </div>
    <div style="margin-top: 20px; width: 100%; display: flex; flex-direction: row; justify-content: center; align-items: center; text-align: center;">
        <div 
            @click="submitLeadForm" 
            :style="'cursor: '+(isSubmissionApproved ? 'pointer' : 'no-drop')+'; background-color: '+(isSubmissionApproved ? '#000' : '#e2e2e2')+'; color: white; padding-left: 30px; padding-right: 30px; padding-top: 10px; padding-bottom: 10px; border-radius: 15px;'">
            Submit{{loading ? 'ting...' : ''}}
        </div>
        <div @click="$emit('closed')" style="cursor: pointer; border: 1px solid #a2a2a2; color: #a2a2a2; margin-left: 20px; padding-left: 30px; padding-right: 30px; padding-top: 10px; padding-bottom: 10px; border-radius: 15px;">
            Cancel
        </div>
    </div>
  </div>
</template>

<script>
import {VueRecaptcha} from 'vue-recaptcha';

export default {
    components: { VueRecaptcha },
    data() {
        return {
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            approve_submission: false,
            loading: false
        }
    },
    computed: {
        getWarning() {
            return this.getFormProps.warning
        },
        getWarningMessage() {
            return this.getFormProps.warning_message
        },
        getFormProps() {
            return this.$store.state.master.props
        },
        isSubmissionApproved() {
            return this.approve_submission
        }
    },
    methods: {
        submitLeadForm() {
            
            let valid = true
            this.$store.state.master.props.warning = false
            
            if(!this.isSubmissionApproved) {
                return
            }
            
            if(this.getFormProps.first_name.length === 0) {
                valid = false
            }
            if(this.getFormProps.last_name.length === 0) {
                valid = false
            }
            if(this.getFormProps.email_address.length === 0) {
                valid = false
            }
            if(this.getFormProps.mobile_number_calling_code.length === 0) {
                valid = false
            }
            if(this.getFormProps.mobile_number.length === 0) {
                valid = false
            }
            if(this.getFormProps.brand_name.length === 0) {
                valid = false
            }

            if(!valid) {
                this.$store.state.master.props.warning = true
                this.$store.state.master.props.warning_message = 'Some of the information is missing or is in-correct,<br>please fill them out!!!'
            } else {
                this.loading = true
                this.$store.dispatch('submitLead', this.getFormProps)
            }

        }
    },
    mounted() {
        setTimeout(() => {

            let countryFilter = this.$store.getters.getCountryList.filter(t => t.currency_short.match(this.$store.getters.getVisitorGeographyDetail.country))
            if(countryFilter.length>0) {
                console.log(JSON.stringify(this.$store.getters.getVisitorGeographyDetail))
            
                this.$store.state.master.props.mobile_number_calling_code = '+'+countryFilter[0].calling_code+' '+countryFilter[0].country_name
            }            
        }, 100);
        this.$store.state.master.props.warning = false
        this.loading = false
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SignUp/Form.vue